import { round } from '../../../../modules/tradebuilder-v2/util'
import { Currency, LinkButton, Space } from '../../atoms'
import { NumberInput } from '../../atoms/number-input'
import { Percent } from '../../atoms/percent'
import { StyledAssetTable } from './primitives'

export type SettlementTransferAsset = {
  actualWeight: number
  baseValue: number
  id: string
  name: string
  originalPurchasePrice: number
  price: number
  targetWeight: number
  units: number
  value: number
}

export type SettlementTransferTableProps = {
  assets?: SettlementTransferAsset[]
  onChangeAssetUnits: (id: string, units: number) => void
  onChangePurchasePrice: (id: string, purchasePrice: number) => void
  onClickAsset?: (id: string) => void
}

export function SettlementTransferTable({
  assets,
  onChangeAssetUnits,
  onChangePurchasePrice,
  onClickAsset
}: SettlementTransferTableProps) {
  return (
    <StyledAssetTable>
      <thead>
        <tr>
          <th className="asset">Asset</th>
          <th className="asset">Current price (ZAc)</th>
          <th className="price">Original purchase price (ZAc)</th>
          <th className="units">Units</th>
          <th className="weight">Portfolio Target Weight</th>
          <th className="weight">Actual Weight</th>
          <th className="total">Base Value</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(assets) &&
          assets.map(asset => (
            <tr key={asset.name}>
              <td className="asset">
                {onClickAsset !== undefined ? (
                  <LinkButton underline onClick={() => onClickAsset(asset.id)}>
                    {asset.name}
                  </LinkButton>
                ) : (
                  asset.name
                )}
              </td>
              <td className="asset">{round(asset.price, 2)}</td>
              <td className="price">
                <Space isflex alignItems="center">
                  <NumberInput
                    value={
                      asset.originalPurchasePrice === null || asset.originalPurchasePrice === 0
                        ? ''
                        : asset.originalPurchasePrice
                    }
                    onChange={v => onChangePurchasePrice(asset.id, Number(v.target.value))}
                  />
                </Space>
              </td>
              <td className="units">
                <Space isflex alignItems="center">
                  <NumberInput
                    value={asset.units === null || asset.units === 0 ? '' : asset.units}
                    onChange={v => onChangeAssetUnits(asset.id, Number(v.target.value))}
                  />
                </Space>
              </td>
              <td className="weight">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.targetWeight === null ? null : asset.targetWeight * 100}
                />
              </td>
              <td className="weight">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.actualWeight === null ? null : asset.actualWeight * 100}
                />
              </td>
              <td className="total">
                <Currency value={asset.baseValue} />
              </td>
            </tr>
          ))}
      </tbody>
    </StyledAssetTable>
  )
}
